import { IState } from "./iState";

export const initialState: IState = {
    authProcess: true,
    getServerProcess: false,
    settingsLoading: true,
    creatingServer: false
};